import {useEffect, useState} from "react";

export const useNow = () => {
    const [now, setNow] = useState(new Date())
    useEffect(() => {
        setNow(new Date())
    }, [])
    return now
}